export const ROUTE_LOGIN = "/login";
export const ROUTE_HOME = "/";
export const ROUTE_TENANTS = "/tenants";
export const ROUTE_TENANT_USERS = "/tenants/users";
export const ROUTE_TENANT_ROLES = "/tenants/roles";
export const ROUTE_TENANT_CREDITS = "/tenants/credits";
export const ROUTE_TENANT_BRAND = "/tenants/brand";
// CR-111: `Catalog` top-level replaced by `Themes`. Only slug-keyed detail
// + categories placeholder remain in the new IA; `catalog_items` is
// deferred to a follow-up Store CR. Redirects from the old `/catalog/*`
// paths live in App.tsx for one release so bookmarks don't 404.
export const ROUTE_THEMES = "/themes";
export const ROUTE_THEMES_CATEGORIES = "/themes/categories";
export const ROUTE_THEME_DETAIL = "/themes/:slug";
export const ROUTE_SERVICE_REQUESTS = "/service-requests";
export const ROUTE_OPERATORS = "/operators";
export const ROUTE_SYSTEM_CONFIG = "/system-config";
// CR-117: HQ-only escalations table.
export const ROUTE_ESCALATIONS = "/escalations";
// ATE-CR-159: HQ-only email-notification verification admin page.
export const ROUTE_NOTIFICATIONS_VERIFICATIONS =
  "/admin/notifications/verifications";
// ATE-CR-164: deep-link variant so refresh / shareable URL re-hydrates the
// status panel from `verificationId` in the URL. Both routes mount the
// same VerificationsPage component.
export const ROUTE_NOTIFICATIONS_VERIFICATION_DETAIL =
  "/admin/notifications/verifications/:verificationId";
